import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORPROPOSAL } from "../../../../utils/constants";
import { RFPInterface } from "../../../../models/ProcurementModule/RequestForProposal";
import RFPService from "../../../../services/procurementService/RFPService";

const useRFP = (page: number, pageSize: number) =>
  useQuery<RFPInterface[], Error>({
    queryKey: [CACHE_KEY_REQUESTFORPROPOSAL, page, pageSize],
    queryFn: () => RFPService.GetAll(page, pageSize),
    initialData: [],
  });

export default useRFP;
